const MACHINE_STATUS_CONFIG = {
    charging: { bgColor: "#1AC69E", label: "Charging", textColor: "#ffffff" },
    discharging: { bgColor: "#FB5A00", label: "Discharging", textColor: "#ffffff" },
    faulted: { bgColor: "#990000", label: "Faulted", textColor: "#ffffff" },
    idle: { bgColor: "#8CBAFF", label: "Idle", textColor: "#ffffff" },
    inactive: { bgColor: "#A3A3A3", label: "Inactive", textColor: "#ffffff" },
    notreporting: { bgColor: "#808080", label: "Not Reporting", textColor: "#ffffff" },
    off: { bgColor: "#909090", label: "Off", textColor: "#ffffff" },
    transporting: { bgColor: "#F739E7", label: "Transporting", textColor: "#ffffff" },
    trickle: { bgColor: "#91F2E6", label: "Trickle", textColor: "#ffffff" },
    unavailable: { bgColor: "#9CA3AF", label: "Unavailable", textColor: "#ffffff" },
    working: { bgColor: "#2980B9", label: "Working", textColor: "#ffffff" }
};
const ESS_STATUS_CONFIG = {
    charging: { bgColor: "#1AC69E", label: "Charging", textColor: "#ffffff" },
    discharging: { bgColor: "#FB5A00", label: "Discharging", textColor: "#ffffff" },
    faulted: { bgColor: "#990000", label: "Faulted", textColor: "#ffffff" },
    idle: { bgColor: "#8CBAFF", label: "Idle", textColor: "#ffffff" },
    inactive: { bgColor: "#A3A3A3", label: "Inactive", textColor: "#ffffff" },
    notreporting: { bgColor: "#808080", label: "Not Reporting", textColor: "#ffffff" },
    off: { bgColor: "#909090", label: "Off", textColor: "#ffffff" },
    selfdischarge: { bgColor: "#8E44AD", label: "Self Discharge", textColor: "#ffffff" },
    trickle: { bgColor: "#91F2E6", label: "Trickle", textColor: "#ffffff" },
    unavailable: { bgColor: "#9CA3AF", label: "Unavailable", textColor: "#ffffff" }
};
const CHARGER_STATUS_CONFIG = {
    available: { bgColor: "#1AC69E", label: "Available", textColor: "#ffffff" },
    inoperable: { bgColor: "#D80000", label: "Inoperable", textColor: "#ffffff" },
    occupied: { bgColor: "#0066FF", label: "Occupied", textColor: "#ffffff" },
    unknown: { bgColor: "#808080", label: "Unknown", textColor: "#ffffff" }
};
export const getAssetStatusPill = (assetSourceType, assetStatus) => {
    if (!assetStatus)
        return null;
    // Normalise: lower-case, strip whitespace and underscores
    let key = assetStatus.toLowerCase().replace(/[\s_]+/g, "");
    // AC_Charging / DC_Charging are treated the same as Charging
    if (key === "accharging" || key === "dccharging")
        key = "charging";
    const type = assetSourceType?.toUpperCase();
    if (type === "MACHINE")
        return MACHINE_STATUS_CONFIG[key] ?? null;
    if (type === "ESS")
        return ESS_STATUS_CONFIG[key] ?? null;
    if (type === "CHARGER")
        return CHARGER_STATUS_CONFIG[key] ?? null;
    return null;
};
// Figma "asset status badge" tokens for the refreshed Live Dashboard: a light fill with dark
// text, replacing the legacy solid fill with white text. Statuses the design doesn't cover keep
// their existing colours so nothing renders unstyled.
const REFRESHED_BADGE_CONFIG = {
    charging: { bgColor: "#cae5c7", textColor: "#006618" },
    discharging: { bgColor: "#ffd5bd", textColor: "#9c3900" },
    idle: { bgColor: "#bce2ff", textColor: "#015394" }
};
export const getRefreshedStatusPill = (pill) => {
    const key = pill.label.toLowerCase().replace(/[\s_]+/g, "");
    return { ...pill, ...REFRESHED_BADGE_CONFIG[key] };
};
